var map = {
	"./W-1-F.png": "d210",
	"./W-2-F.png": "58f6",
	"./W-3-F.png": "5029",
	"./W-4-F.png": "5bad",
	"./W-5-F.png": "4c01",
	"./W1-1-F.png": "0b6c",
	"./W1-2-F.png": "603b",
	"./W1-3-F.png": "24dc",
	"./W1-4-F.png": "897f",
	"./W1-5-F.png": "431e",
	"./W2-1-F.png": "fcdb",
	"./W2-2-F.png": "6d60",
	"./W2-3-F.png": "3b1b",
	"./W2-4-F.png": "5fb3",
	"./W2-5-F.png": "5849",
	"./W3-1-F.png": "04e6",
	"./W3-2-F.png": "2b50",
	"./W3-3-F.png": "13bb",
	"./W3-4-F.png": "8e67",
	"./W3-5-F.png": "7107"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "72bd";